import { render } from "./PieceBis.vue?vue&type=template&id=3781b7f3&scoped=true"
import script from "./PieceBis.vue?vue&type=script&lang=js"
export * from "./PieceBis.vue?vue&type=script&lang=js"

import "./PieceBis.vue?vue&type=style&index=0&id=3781b7f3&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3781b7f3"]])

export default __exports__